import { render, staticRenderFns } from "./SidebarAddNewCategory.vue?vue&type=template&id=209d2cb1&"
import script from "./SidebarAddNewCategory.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewCategory.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports